<template>
  <div class="container" v-loading="loading">
    <el-button type="text" @click="addToDownload">添加</el-button>
    <canvas :id="`myCanvas-${_uid}`" width="400" height="300" refs="myCanvas"></canvas>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: 'regionsWrapper',
  props: {
    regions: '',
    image: ''
  },
  components: {},
  data () {
    return {
      loading: false
    };
  },
  mounted () {
    this.loading = true;
    setTimeout(() => {
      this.drawRegions();
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapMutations(['addToDownloadImageList']),
    addToDownload () {
      let target = this.$_.find(this.downloadImageList, (a) => {
        return a === this.image;
      });
      if (target) {
        return this.$message.error('该图片已经被添加');
      } else {
        this.$message.warning('添加成功');
        this.addToDownloadImageList(this.image);
      }
    },
    computedStyle (regions) {
      this.$nextTick(() => {
        let image = this.$refs.image;
        let size = {
          width: image.offsetWidth,
          height: image.offsetHeight
        };
        console.log(size);
        console.log({
          width: regions.w * size.width + 'px',
          left: regions.x * size.width + 'px',
          top: regions.y * size.height + 'px',
          height: regions.y * size.height + 'px'
        });
        return {
          width: regions.w * size.width + 'px',
          left: regions.x * size.width + 'px',
          top: regions.y * size.height + 'px',
          height: regions.y * size.height + 'px'
        };
      });
    },
    drawRegions () {
      this.$nextTick(() => {
        // let c = this.$refs['myCanvas'];
        let c = document.getElementById(`myCanvas-${this._uid}`);
        let image = new Image();
        image.src = this.image; ;
        let ctx = c.getContext('2d');
        let regions = this.regions;
        let max = 400;
        image.onload = function () {
          let w = image.width;
          let h = image.height;
          let persant = 400 / w;
          c.width = 400;
          c.height = h * persant;

          ctx.drawImage(image, 0, 0, w, h, 0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.strokeStyle = '#ff01ea';
          ctx.lineWidth = 2;
          regions.forEach(a => {
            ctx.rect(ctx.canvas.width * a.x, ctx.canvas.height * a.y, ctx.canvas.width * a.w, ctx.canvas.height *
              a.h);
          });
          ctx.stroke();
        };
      });
    }
  },
  computed: {
    ...mapGetters([
      'downloadImageList'
    ])
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  width: 400px;
  height: auto;
  .region-item {
    display: inline-block;
    position: absolute;
    border: 1px solid #409EFF;
  }
}
</style>
